import { render, staticRenderFns } from "./HorizontalContentCard.vue?vue&type=template&id=31ae47e0&scoped=true&"
import script from "./HorizontalContentCard.vue?vue&type=script&lang=ts&"
export * from "./HorizontalContentCard.vue?vue&type=script&lang=ts&"
import style0 from "./HorizontalContentCard.vue?vue&type=style&index=0&id=31ae47e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ae47e0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
